"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _variables = require("../variables");

function _default() {
  var _ref;

  var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var palette = theme.palette,
      rightTop = "".concat(_variables.X_POSITION_RIGHT, "-").concat(_variables.Y_POSITION_TOP),
      rightBottom = "".concat(_variables.X_POSITION_RIGHT, "-").concat(_variables.Y_POSITION_BOTTOM),
      leftBottom = "".concat(_variables.X_POSITION_LEFT, "-").concat(_variables.Y_POSITION_BOTTOM),
      leftTop = "".concat(_variables.X_POSITION_LEFT, "-").concat(_variables.Y_POSITION_TOP);
  return _ref = {
    root: {
      background: theme.background,
      boxShadow: theme.boxShadow,
      borderRadius: theme.borderRadius,
      zIndex: theme.zIndex,
      position: 'relative'
    },
    item: (0, _defineProperty2["default"])({
      background: palette.itemBackground,
      fontSize: theme.itemFontSize,
      lineHeight: theme.itemLineHeight,
      color: theme.itemColor,
      transitionProperty: 'background',
      transitionDuration: palette.transitionDuration,
      transitionTimingFunction: palette.transitionFunction,
      paddingTop: theme.itemPaddingTop,
      paddingRight: theme.itemPaddingRight,
      paddingBottom: theme.itemPaddingBottom,
      paddingLeft: theme.itemPaddingLeft
    }, '&:hover', {
      background: theme.hoverItemBackground,
      cursor: theme.hoverItemCursor
    }),
    itemWrapper: {
      position: 'relative'
    }
  }, (0, _defineProperty2["default"])(_ref, rightTop, {
    position: 'absolute',
    top: 0,
    left: '100%'
  }), (0, _defineProperty2["default"])(_ref, rightBottom, {
    position: 'absolute',
    bottom: 0,
    left: '100%'
  }), (0, _defineProperty2["default"])(_ref, leftBottom, {
    position: 'absolute',
    right: '100%',
    bottom: 0
  }), (0, _defineProperty2["default"])(_ref, leftTop, {
    position: 'absolute',
    right: '100%',
    top: 0
  }), _ref;
}